import { css, useTheme } from "@emotion/react";
import React from "react";
import { UpsunTheme } from "@upsun/react-component-library/src/themes";
import Heading from "@upsun/react-component-library/src/components/Heading";
import { checkmarks, mediaQueries, pxToRem } from "@upsun/react-component-library/src/styles";
import { fontSize, gridCard } from "../../utils/pricing-page-styles";
import colorsLight from "@upsun/react-component-library/src/styles/colors-light";

type ProjectFeeProps = {
  pricingInfo: PricingInfoType
  currency: string
};

const ProjectFee: React.FC<ProjectFeeProps> = ({ pricingInfo, currency, ...props }) => {
  const theme = useTheme() as UpsunTheme;

  const userManagementInnerGrid = css`
    background: ${theme.name === "light" ? colorsLight.CanvasDefault : "#0e1113"};
    border-radius: ${pxToRem(8)};
    padding: ${pxToRem(20)};
  `;

  const userManagementContainer = css`
    ${mediaQueries.md} {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  `;

  const checkmarksCustom = css`
    ${checkmarks};

    li::before {
      ${theme.name === "light" ? `
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='tick'%3E%3Cpath id='Icon' d='M9.99999 15.1C9.69999 15.1 9.49999 15 9.29999 14.8L5.09999 10.6C4.69999 10.2 4.69999 9.60002 5.09999 9.20002C5.49999 8.80002 6.09999 8.80002 6.49999 9.20002L9.99999 12.7L17.5 5.20002C17.9 4.80002 18.5 4.80002 18.9 5.20002C19.3 5.60002 19.3 6.20002 18.9 6.60002L10.7 14.8C10.5 15 10.3 15.1 9.99999 15.1Z' fill='%234d38cc'/%3E%3C/g%3E%3C/svg%3E%0A");
      ` :
      `
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='tick'%3E%3Cpath id='Icon' d='M9.99999 15.1C9.69999 15.1 9.49999 15 9.29999 14.8L5.09999 10.6C4.69999 10.2 4.69999 9.60002 5.09999 9.20002C5.49999 8.80002 6.09999 8.80002 6.49999 9.20002L9.99999 12.7L17.5 5.20002C17.9 4.80002 18.5 4.80002 18.9 5.20002C19.3 5.60002 19.3 6.20002 18.9 6.60002L10.7 14.8C10.5 15 10.3 15.1 9.99999 15.1Z' fill='%23A090FF'/%3E%3C/g%3E%3C/svg%3E%0A");
      `
    }
  }`;

  return (
    <div css={gridCard}>
      <div>
        <Heading level={4}>Start for free</Heading>
        <div css={fontSize}>
          {pricingInfo.freeTrial[currency]} to begin
        </div>
      </div>
      <div>
        <ul css={checkmarksCustom}>
          <li>15-day free trial</li>
          <li>Monthly credit covering <strong>1 project fee + 1 user license</strong></li>
          <li>Full access to all enterprise-grade features</li>
          <li>No credit card required</li>
        </ul>
      </div>
      <div css={userManagementContainer}>
        <div css={userManagementInnerGrid}>
          Trusted by teams running regulated and production workloads across <a href="/industry/financial-services/">finance</a>, <a href="/industry/saas/">SaaS</a>, and <a href="/industry/higher-education/">higher ed</a>. 
        </div>
      </div>
    </div>
  );
};

export default ProjectFee;
